import ApplicationBaseController from "./application_base_controller"

export default class extends ApplicationBaseController {

}
